<template>
    <div class="liveitems">
     <div class="home-right-li" @click="Jinruzhibojian(liveDetailitems.live.id,liveDetailitems.item.virtualId)">
        <div class="home-right-info">
         <el-image :src="liveDetailitems.item.cover + '?timestamp=' + imageTime">
           <div slot="error" class="image-slot">
              <img src="@/assets/img/defaultLogo.png" alt="" />
           </div>
         </el-image>
          <div class="hotValueImg"  v-if="liveDetailitems.item.fixHeatFlag == 1">
            <img src="@/assets/img/hotlabels.png" alt="" srcset="">
          </div>
        </div>
        <div class="home-right-div">
          <div class="home-right-div-title myfont">
            {{ liveDetailitems.item.title }}
          </div>
          <div class="hotValue">
            <div class="video_list_img">
              <img :src="liveDetailitems.user.avatar" alt="" />
            </div>
            <div class="home-right-div-title2">
              <div class="name2 myfont1">
                {{ liveDetailitems.user.nickname  }}
              </div>
              <div>
                <div v-if="isCare(liveDetailitems.user.uid)" @click.stop="guanzhu(liveDetailitems.user, false)" class="careOk">
                  已关注
                </div>
                <div v-else @click.stop="guanzhu(liveDetailitems.user, true)" class="attention">
                  关注
                </div>
                <div class="hotName">
                  <img src="https://oss.ansongqiubo.com/assets/home/icon_huo@2x.png" alt="" />
                  <div>{{ liveDetailitems.item.heatValue }}</div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import axios  from 'axios'
  import qs from 'qs'
  export default {
    props:{
      liveDetailitems:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data() {
      return {
        key: 1,
        liveDetails:{},
        careList:[],
        imageTime:''
      }
    },
    created() {
      this.getcareList();
      this.imageTime = Date.parse(new Date()) / 1000;
    },
    methods:{
      Jinruzhibojian(id,virtualId) {
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: {
            roomId: id,
            virtualId
          },
        });
        window.open(neww.href, "_self");
      },
      isCare(uid) {
        let arr = this.careList.filter((item) => item.uid == uid);
        if (arr && arr.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      // 关注主播
      guanzhu(val, state) {
       this.token = localStorage.getItem("token");
       if(!this.token){
         // this.$refs.navRef.Longin();
         this.$emit('login');
         console.log('跳转登录');
         return
       }
        if (state) {
          axios({
            headers: {
              device: "iOS",
              packageId: "1",
              version: "1.0.0",
              "authToken": this.token,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                console.log(data);
                return data;
              },
            ],
            url: this.api + "/v1/relation/follow",
            method: "post",
            data: {
              actionUid: val.uid,
            },
          }).then((res) => {
            this.$message({
              message: "关注成功",
              type: "success",
            });
            this.getcareList(2);
            console.log("关注主播", res);
          });
        } else {
          this.$confirm("取关该主播将无法及时收到消息, 是否取关?", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              axios({
                headers: {
                  device: "iOS",
                  packageId: "1",
                  version: "1.0.0",
                  "authToken": this.token,
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                transformRequest: [
                  function(data) {
                    //在请求之前对data传参进行格式转换
                    data = qs.stringify(data);
                    console.log(data);
                    return data;
                  },
                ],
                url: this.api + "/v1/relation/unfollow",
                method: "post",
                data: {
                  actionUid: val.uid,
                },
              }).then((res) => {
                console.log(res);
                this.$message({
                  message: "取关成功",
                  type: "success",
                });
                this.getcareList(2);
              });
            })
            .catch(() => {});
        }
      },
      // 获取关注列表
      async getcareList(type=1) {
       this.token = localStorage.getItem("token");
       if (this.token){
         let list = await this.$store.dispatch('getUserFollowData',type);
         // console.log('我的关注列表·',list);
         this.careList = list;
       }
      },
    }
  }
</script>

<style lang="scss">
    .liveitems {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 100%;
      justify-content: flex-start !important;

      .home-right-div-title2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width:96%;

        .hotName {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;

          img {
            margin-right: 2px;
            width: 11px;
            height: 11px;
          }
        }

        .name2 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          max-width: 130px;
        }
      }
      .home-right-div {
        .home-right-div-title {
          font-size: 14px;
          height: 21px;
          width:96%;
        }
      }
      .home-right-div {
        /* height: 30%; */
        display: flex;
        justify-content: center;
        flex-flow: column wrap;
        flex: 2;
        box-sizing: border-box;
        padding:6px 8px;
        position: relative;
        .hotValue {
          display: flex;
          margin-top: 4px;
          width: 100%;
        }

        .video_list_img {
          width: 22px;
          height: 22px;
          margin-right: 4px;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 22px;
            height: 22px;
          }
        }
      }

      .home-right-li {
        display: flex;
        flex-direction: column;
        width: 240px;
        height: 206px;
        background: #FFFFFF;
        border-radius: 4px;
        box-sizing: border-box;
        list-style-type: none;
        background-color: #fff;
        overflow: hidden;
        transition: all 0.3s;
        margin: 0 12px 20px 0;
      }

      .attention,
      .careOk {
        display: block;
        position: absolute;
        top:8px ;
        right:6px;
        width: 46px;
        height: 20px;
        cursor: pointer;
        display: block;
        padding: 2px 4px;
        border-radius: 18px;
        color: #fff;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
      }

      .home-right-li:hover {
        transform: scale(1.03);
        transition: all 0.2s;
        box-sizing: border-box;

        .home-right-div{
          position: relative;
        }


            .careOk {
              background: rgb(231, 231, 231);
            }

            .attention {

              background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
            }

        // box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.2);
        // .home-right-div {
        //   // padding: 5px;
        //   .home-right-div-title {
        //     font-size: 14px;
        //     width: 200px;
        //     height: 21px;
        //   }

        //   .hotValue {
        //     user-select: none;
        //     display: flex;
        //     align-items: center;
        //     width: 100%;
        //     .home-right-div-title2 {
        //       display: flex;
        //       align-items: flex-start;
        //       flex-direction: column;
        //       flex: 2;
        //       .name2,
        //       .hotName {
        //         font-size: 12px;
        //       }
        //     }

        //     .careOk {
        //       cursor: pointer;
        //       display: block;
        //       padding: 6px 18px;
        //       border-radius: 18px;
        //       background: rgb(231, 231, 231);
        //       color: #fff;
        //       font-size: 14px;
        //       text-align: center;
        //     }

        //     .attention {
        //       cursor: pointer;
        //       display: block;
        //       padding: 6px 18px;
        //       border-radius: 18px;
        //       background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
        //       color: #fff;
        //       font-size: 14px;
        //       text-align: center;
        //     }
        //   }
        // }
      }
      .hotValueImg{
        width: 62px;
        height: 62px;
        position:absolute;
        left: 0;
        top: 0;
        img{
          width: 62px !important;
          height: 62px !important;
        }
      }
      .home-right-info {
       width: 240px;
       height: 135px;
       border-radius: 4px 4px 0px 0px;
        position: relative;
        .el-image{
          img{
            width: 240px;
            height: 135px;
          }
        }
        .image-slot{
          img{
            width: 240px;
            height: 135px;
          }
        }
      }

      .home-right-info>img {
       width: 240px;
       height: 125px;
       border-radius: 4px 4px 0px 0px;
      }

      .home-right-info-zhibo {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 84px;
        height: 30px;
        border-radius: 6px;
        line-height: 30px;
        text-align: center;
      }

      .home-right-info-div {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 0.3s ease-out;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/lz_liveItem.vue